var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { GroupContainer } from './Group';
import { PanelContainer } from './Panel';
import { TabContainer } from './Tab';
import { TabsContainer } from './Tabs';
import { ExtensionContainer } from './Extension';
import { TableContainer } from './Table';
export var baseContainers = {
    group: function (props) { return React.createElement(GroupContainer, __assign({}, props)); },
    panel: function (props) { return React.createElement(PanelContainer, __assign({}, props)); },
    extension: function (props) { return React.createElement(ExtensionContainer, __assign({}, props)); },
    tab: function (props) { return React.createElement(TabContainer, __assign({}, props)); },
    tabs: function (props) { return React.createElement(TabsContainer, __assign({}, props)); },
    table: function (props) { return React.createElement(TableContainer, __assign({}, props)); },
};
//# sourceMappingURL=index.js.map